const lower = (a) => {
  return (typeof a === 'undefined' || a === null) ? a : a.toString().toLowerCase()
}

const upper = (a) => {
  return (typeof a === 'undefined' || a === null) ? a : a.toString().toUpperCase()
}

export {
  lower,
  upper
}



// WEBPACK FOOTER //
// ./src/util/formatting.js